/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class CostOptimizationViewRecommendationResponse {
    getFixupPrototypeFunction() { return CostOptimizationViewRecommendationResponse.fixupPrototype; }

    static newInstance(model: Partial<CostOptimizationViewRecommendationResponse>): CostOptimizationViewRecommendationResponse {
        let obj = Object.assign(new CostOptimizationViewRecommendationResponse(), model);
        CostOptimizationViewRecommendationResponse.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<CostOptimizationViewRecommendationResponse>): CostOptimizationViewRecommendationResponse {
        if (!model) return null;
        return CostOptimizationViewRecommendationResponse.newInstance(<CostOptimizationViewRecommendationResponse> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: CostOptimizationViewRecommendationResponse) {
        if (!obj) return;

        models.CostOptimizationViewRecommendationResponse.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: CostOptimizationViewRecommendationResponse): boolean {
        Object.setPrototypeOf(obj, CostOptimizationViewRecommendationResponse.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.total_count === undefined) {
            this.total_count = 0;
        }
        if (this.page_count === undefined) {
            this.page_count = 0;
        }
        if (this.recommendation_data) {
            for (let val of this.recommendation_data) {
                models.RecommendationView.fixupPrototype(val);
            }
        }
    }

    /**
     * Total Count
     */
    total_count: number;

    /**
     * Page Count
     */
    page_count: number;

    /**
     * Total Saving Percentage
     */
    overall_savings_percentage: string;

    /**
     * Potential cost savings total information
     */
    potential_cost_savings_total_info: string;

    /**
     * Potential cost savings total
     */
    potential_cost_savings_total: string;

    recommendation_data: Array<models.RecommendationView>;

}
